import React from "react";
var __jsx = React.createElement;
import stl from "./ScheduleLandingComponent.module.css";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
import { useState, useEffect } from "react";
import DeleteConfirmation from "./DeleteConfirmation";
import { createTimestampAndNextNDays } from "@/utils/GlobalJavascriptFunction";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
import CancelReasonsModal from "@/components/shared/CancelReasonsModal/CancelReasonsModal";
import rejectReasons from "@data/lookups/erp_cancel_reason.json";
import appointmentDelete from "@/apis/scheduleApis/appointmentDelete";
var ScheduleLandingComponent = function ScheduleLandingComponent(_ref) {
  var t = _ref.t,
    pageData = _ref.pageData,
    requestId = _ref.requestId,
    navigate = _ref.navigate,
    scheulestep = _ref.scheulestep;
  var lang = useLang();
  var _useState = useState(false),
    ShowPopUp = _useState[0],
    setShowPopUp = _useState[1];
  var _useState2 = useState(null),
    myTimestamp = _useState2[0],
    setMyTimestamp = _useState2[1];
  var _useState3 = useState(false),
    isReasonsModalOpen = _useState3[0],
    setIsReasonsModalOpen = _useState3[1];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  useEffect(function () {
    setMyTimestamp(createTimestampAndNextNDays(pageData === null || pageData === void 0 ? void 0 : pageData.timestamp));
  }, [pageData]);

  // Called from DeleteConfirmation red button: close the popup, open reasons modal
  var handleCancelRequest = function handleCancelRequest() {
    setShowPopUp(false);
    setIsReasonsModalOpen(true);
  };

  // Called on CancelReasonsModal submit
  var handleCancelSubmit = function handleCancelSubmit(reasonId, note) {
    appointmentDelete({
      request_id: requestId,
      cancellation_reason_id: reasonId,
      note: note || "text"
    }).then(function (res) {
      var _res$data;
      setIsReasonsModalOpen(false);
      if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 200) {
        navigate(createUrl("/schedule/".concat(requestId), {
          schedulestep: "cancelled"
        }));
      } else {
        navigate(createUrl("/schedule/".concat(requestId), {
          schedulestep: "error"
        }));
      }
    })["catch"](function () {
      setIsReasonsModalOpen(false);
      navigate(createUrl("/schedule/".concat(requestId), {
        schedulestep: "error"
      }));
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("i", {
    className: stl.appointmentIcon
  }), /*#__PURE__*/React.createElement("strong", null, pageData === null || pageData === void 0 ? void 0 : pageData.text), /*#__PURE__*/React.createElement("p", null, pageData === null || pageData === void 0 ? void 0 : pageData.description), /*#__PURE__*/React.createElement("div", {
    className: stl.innerContainer
  }, /*#__PURE__*/React.createElement("strong", null, pageData === null || pageData === void 0 ? void 0 : pageData.title), myTimestamp && scheulestep !== "new" && /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: stl.calenderIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("date", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.dayName(lang), " ", (myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.day()) + "/" + (myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.month()) + "/" + (myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.year())))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: stl.clockIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("time", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.timeForView(lang))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: stl.locationIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("location", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_en) === "" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_ar) === "" && (pageData === null || pageData === void 0 ? void 0 : pageData.location)), /*#__PURE__*/React.createElement("span", null, lang === "ar" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_ar) && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_ar) !== "" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_ar)), /*#__PURE__*/React.createElement("span", null, lang === "en" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_en) && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_en) !== "" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_en))))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      navigate(createUrl("/schedule/".concat(requestId), {
        schedulestep: "reschedule"
      }));
    },
    className: ["blueBtn", stl.btn].join(" ")
  }, t("reschedule_appointment", {
    ns: "web_Schedule"
  })), /*#__PURE__*/React.createElement("button", {
    className: [stl.btn, stl.deleteAppointment].join(" "),
    onClick: function onClick() {
      setShowPopUp(true);
    }
  }, t("cancel_appointment", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement(SharedPopUp, {
    maxWidth: "563px",
    show: ShowPopUp,
    onClose: function onClose() {
      setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement(DeleteConfirmation, {
    request_id: requestId,
    t: t,
    closePopup: function closePopup() {
      return setShowPopUp(false);
    },
    onCancelRequest: handleCancelRequest
  })), /*#__PURE__*/React.createElement(CancelReasonsModal, {
    isOpen: isReasonsModalOpen,
    onClose: function onClose() {
      return setIsReasonsModalOpen(false);
    },
    onSubmit: handleCancelSubmit,
    reasons: rejectReasons
  }));
};
export default ScheduleLandingComponent;